import { render, staticRenderFns } from "./GridDatasets.vue?vue&type=template&id=dff572e2&scoped=true"
import script from "./GridDatasets.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridDatasets.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridDatasets.vue?vue&type=style&index=0&id=dff572e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff572e2",
  null
  
)

export default component.exports